module.exports = __webpack_public_path__ + "static/media/mypoolitzer.0deef330.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mypoolitzer.svg
// module id = 626
// module chunks = 0 1 2